import announceRoutes from './routes'

/* @ngInject */
const announceCtrl = (
  $scope,
  $state,
  $$wagon,
  $$train,
  $$railway,
  $$owner,
  toaster,
  utils,
) => {
  $scope.$$wagon = $$wagon
  $scope.$$train = $$train
  $scope.$$railway = $$railway
  $scope.$$owner = $$owner

  $scope.fieldsOptions = $$wagon.metadata.fields

  // Separate state for announce functionality
  $scope.announceData = {
    mySearchedWagons: [],
    myWagonSearchdata: {},
    mySelectedWagons: [],
    mySelectedIds: [],
    mySelectedLength: 0
  }

  $scope.goToCreateScrapping = () => {
    $state.go(announceRoutes.createScrapping.path)
  }

  $scope.goToReport = () => {
    $state.go(announceRoutes.report.path)
  }

  $scope.goToSelectWagons = () => {
    // Clear announce-specific state
    $scope.announceData.mySearchedWagons.splice(0, $scope.announceData.mySearchedWagons.length)
    $scope.announceData.myWagonSearchdata = {}
    $scope.announceData.mySelectedWagons.splice(0, $scope.announceData.mySelectedWagons.length)
    $scope.announceData.mySelectedIds.splice(0, $scope.announceData.mySelectedIds.length)
    $scope.announceData.mySelectedLength = 0
    $state.go(announceRoutes.selectWagons.path)
  }

  $scope.cancelAnnounce = async (_wagonIds) => {
    console.log(_wagonIds)
    try {
      const response = await $$wagon.request.cancelAnnounce(_wagonIds)
      toaster.message(response)
      $scope.goToSelectWagons()
    }
    catch (error) {
      console.warn(error)
    }
  }

  $scope.announceScrapping = async (_wagonIds) => {
    console.log(_wagonIds)
    try {
      const response = await $$wagon.request.announceScrapping(_wagonIds)
      toaster.message(response)
      $scope.goToReport()
    }
    catch (error) {
      console.warn(error)
    }
  }
}

export default announceCtrl



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/maneuver/announce/announce.controller.js